import './heading/heading-home/heading-home';

import './media/gallery/gallery';

import './slider/slider-animaux/slider-animaux';
import './slider/slider-posts/slider-posts';
import './slider/slider-medias/slider-medias';

import './text/text-etapes/text-etapes';
import './text/progress-bar/progress-bar';
